<template>
  <div
    class="w-full max-w-sm rounded-2xl bg-white p-4 shadow-[0_8px_30px_rgba(0,0,0,0.12),0_1px_3px_rgba(0,0,0,0.06)]"
    role="status"
  >
    <template v-if="store.outgoing">
      <div class="flex items-center gap-3">
        <Avatar
          :src="store.outgoing.mentor.avatarUrl"
          size="md"
          disable-lazy-loading
          class="ring-success-500 ring-2 ring-offset-2"
        />
        <div class="min-w-0 flex-1 text-sm">
          <div class="font-semibold">
            Waiting for {{ store.outgoing.mentor.firstName }}
          </div>
          <div class="text-neutral-500">
            {{ store.outgoing.mentor.firstName }} has {{ secondsLeft }} s to
            answer
          </div>
        </div>
        <button
          type="button"
          class="text-sm text-neutral-500 underline underline-offset-4 hover:text-neutral-700"
          @click="store.cancelOutgoing()"
        >
          Cancel
        </button>
      </div>
    </template>

    <template v-else-if="store.unanswered">
      <div class="flex items-start gap-3">
        <Avatar
          :src="store.unanswered.mentor.avatarUrl"
          size="md"
          disable-lazy-loading
        />
        <div class="min-w-0 flex-1 text-sm">
          <div class="font-semibold">
            {{ store.unanswered.mentor.firstName }} can't talk right now.
          </div>
          <p class="mt-1 text-neutral-500">"{{ store.unanswered.message }}"</p>
        </div>
        <button
          type="button"
          class="text-neutral-400 hover:text-neutral-600"
          aria-label="Close"
          @click="store.unanswered = null"
        >
          <XIcon class="size-4" />
        </button>
      </div>
      <BaseButton
        :href="planUrl"
        color="outline-gray"
        size="small"
        is-rounded
        class="mt-3 w-full"
      >
        Book a planned call
      </BaseButton>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Avatar from '@/shared/components/avatar/Avatar.vue'
import BaseButton from '@/shared/components/BaseButton.vue'
import XIcon from '~icons/lucide/x'
import { useInstantSessionsStore } from '@/modules/instant-sessions/stores/instantSessions'
import { useCountdown } from '@/modules/instant-sessions/utils/useCountdown'

const store = useInstantSessionsStore()
const { secondsLeft } = useCountdown(computed(() => store.outgoing?.expiresAt))

// The booking form takes the member's line, so it is not lost.
const planUrl = computed(() => {
  if (!store.unanswered) return '#'
  const params = new URLSearchParams({ message: store.unanswered.message })
  return `/mentors/${store.unanswered.mentor.id}/sessions/new?${params}`
})
</script>
